module.exports = __webpack_public_path__ + "static/media/ic_on_boarding.05122852.png";